import { forwardRef } from "react";
import Button from "./Button";

/**
 * Button component with an icon and content.
 * @param {object} props
 * @param {"xs" | "sm" | "md" | "lg" | "xl" | "2xl" | { fontSize: string; paddingX: string; paddingY: string }} props.size The size of the button.
 * @param {"primary" | "secondary" | "danger"} props.colorTheme The color theme for the button. Defaults to `primary`.
 * @param {{ text: string; show?: boolean; } | undefined} props.tooltipProps Props for the tooltip. To show the tooltip on mouseover, leave the `show` property undefined.
 * @param {React.MouseEventHandler<HTMLButtonElement> | undefined} props.handleOnClick Handler for the button click event.
 * @param {React.ReactNode} props.content Content for the button.
 * @param {React.ReactNode} props.iconComponent The icon component.
 */
function IconContentButton(
    { size, colorTheme = "primary", handleOnClick, content, tooltipProps, iconComponent, ...props },
    ref,
) {
    return (
        <Button
            {...props}
            ref={ref}
            size={size}
            colorTheme={colorTheme}
            handleOnClick={(event) => {
                if (handleOnClick) {
                    handleOnClick(event);
                }
            }}
            tooltipProps={tooltipProps}
            iconComponent={iconComponent}
        >
            {content}
        </Button>
    );
}

export default forwardRef(IconContentButton);
